import { Component, EventEmitter, Output, Input, ElementRef, HostListener } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-dropdown-upload-button',
  imports: [ButtonComponent, NgIf],
  templateUrl: './dropdown-upload-button.component.html',
  styleUrl: './dropdown-upload-button.component.css'
})
export class DropdownUploadButtonComponent {
  show_menu = false;
  @Input() page_name: any = '';
  @Input() show_icon: boolean = true;
  @Output() bulkUpload = new EventEmitter<any>();
  @Output() singleUpload = new EventEmitter<any>();

  constructor(public eref: ElementRef) { }

  openBulk() {
    this.show_menu = false;
    this.bulkUpload.emit();
  }

  openSingle() {
    this.show_menu = false;
    this.singleUpload.emit();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent) {
    if (!this.eref.nativeElement.contains(event.target)) {
      this.show_menu = false;
    }
  }

}
